import { renderTextWithFootnotesReferences } from '../feature-service-types';
import type { ReactNode } from 'react';
import { Children } from 'react';

const transform = (node: ReactNode) => {
  if (typeof node === 'string') {
    return renderTextWithFootnotesReferences(node);
  }
  return node;
};

export function renderReactNodeWithFootnotes(nodes: ReactNode[]) {
  return Children.map(nodes, transform);
}
